import type { PortableTextBlock } from "@portabletext/types";

function hasBlockLevelMarks(block: PortableTextBlock): boolean {
  const children = block.children as Array<{ marks?: string[] }> | undefined;
  const markDefs = block.markDefs as Array<{ _type: string }> | undefined;

  if (!children || !markDefs) {
    return false;
  }

  const usedMarkKeys = new Set(children.flatMap((child) => child.marks || []));

  return markDefs.some(
    (def) =>
      usedMarkKeys.has((def as { _key?: string })._key || "") &&
      def._type === "dynamicPlaceholder",
  );
}

export { hasBlockLevelMarks };
